import React from "react";
import { Text, useMultiStyleConfig, Img } from "@chakra-ui/react";
import { AppLink, type AppLinkProps } from "@/components/AppLink/AppLink";
import { FlexColumn } from "@/components/FlexColumn/FlexColumn";

export interface ArticleListItemProps extends AppLinkProps {
	coverPhotoUrl: string;
	date: string;
	title: string;
	description: string;
	link: string;
}

export default function ArticleListItem({ coverPhotoUrl, date, title, description, link, ...rest }: ArticleListItemProps) {
	const styleParts = useMultiStyleConfig("ArticleListItem");
	return (
		<AppLink {...(styleParts.root as AppLinkProps)} target="_blank" href={link} aria-label={title} {...rest}>
			<Img width={380} height={365} src={coverPhotoUrl} alt="" sx={styleParts.image} />
			<FlexColumn sx={styleParts.contentContainer}>
				<FlexColumn sx={styleParts.dateTitleContainer} mb="10px">
					<Text sx={styleParts.date}>{date}</Text>
					<Text sx={styleParts.title}>{title}</Text>
				</FlexColumn>
				<Text sx={styleParts.description}>{description}</Text>
			</FlexColumn>
		</AppLink>
	);
}
